import { CharacterConfig } from './characters';
import { logger } from '../core/Logger';
import { getCharacterConfig } from '../core/behaviors/characters';

const normalizeIdentifier = (identifier: string): string => {
  const normalized = identifier.replace(/\\/g, '/').toLowerCase();
  const segments = normalized.split('/').filter(Boolean);
  if (segments.length === 0) {
    return normalized;
  }
  const last = segments[segments.length - 1];
  if (last.endsWith('.json')) {
    return last.slice(0, -5);
  }
  return last;
};

export class CharacterConfigLoader {
  static async load(identifier: string): Promise<CharacterConfig> {
    const key = normalizeIdentifier(identifier);
    
    // BehaviorRegistry is the single source of truth for character configs
    const behaviorConfig = getCharacterConfig(key);
    if (behaviorConfig) {
      logger.assets.debug(`Loaded character config from BehaviorRegistry for '${key}'`);
      return behaviorConfig;
    }

    throw new Error(
      `No character config registered for '${identifier}' (normalized: '${key}'). ` +
      `Did you forget to call registerCharacterBehaviors()?`
    );
  }
}
